<div class="wrapper d-flex flex-column justify-content-between" style="height: 100vh;">
  <header>
    <nav class="navbar navbar-expand-lg mb-3 navbar-light" role="navigation">
      <div class="container-fluid">
        <a class="navbar-brand">
          <img class="img-responsive" src="../../../assets/img/logo2.png" alt="App Logo" />
          <span class="logo-text"> Partner Portal</span>
        </a>        
      </div>
    </nav>
  </header>
  <section>
    <div style="height: calc(100vh - 180px);">
      <h4 class="text-blue-600 text-center my-4">This link is no longer valid for edits.</h4>
    </div>
  </section>
  <footer>
    <div class="footer-wrapper">
      <div>&copy;
        {{settings?.app?.year}}
        {{ settings?.app?.name }}
      </div>
      <div>
        <a [href]="settings?.app?.complainceLink" target="_blank">{{ settings?.app?.complainceDescription }}</a>
      </div>
    </div>
  </footer>
</div>